import commonGlobals from '@opendoor/shared-fe/build/commonGlobals';
import { getRailsEnv } from '@opendoor/shared-fe/build/railsEnv';

declare var process: any;
declare var global;

const effectiveGlobal = typeof global !== 'undefined' ? global : window;

const odRailsEnv = getRailsEnv(process.env.RAILS_ENV);
const secrets = commonGlobals[odRailsEnv];

let deployType = effectiveGlobal.odDeployType;
if (odRailsEnv === 'development') {
  deployType = undefined;
}

let railsUrl = secrets.railsUrl;
if (
  typeof window !== 'undefined' &&
  !(window as any).odExtractedApp &&
  // exclude storybook - that's not rails
  window.location.host !== 'localhost:9001'
) {
  // "if we're running in Rails, use the window location, not the secrets version"
  railsUrl = window.location.protocol + '//' + window.location.host;
}

export const RAILS_ENV = odRailsEnv;
export const FRONTEND_RELEASE_SHA = process.env.REACT_APP_RELEASE_SHA;
// Google API calls use this project for billing and API keys:
// https://console.cloud.google.com/apis/credentials?project=val-tool-3-1495755979574&organizationId=727186813944
export const GOOGLE_MAPS_API_KEY = secrets.googleMaps;
export const SEGMENT_MARKET_JS_KEY = secrets.segment;
export const GOOGLE_ANALYTICS_TOKEN = secrets.googleAnalytics;
export const WEB_API_URL = secrets.webApiUrl;
export const FACEBOOK_APP_ID = secrets.facebookAppID;
export const GOOGLE_CLIENT_ID = secrets.googleClientID;

export const ADMIN_CLIENT_UPLOAD_BUCKET = `opendoor-admin-client-upload-${RAILS_ENV}`;
export const CONSUMER_BFF_URL = secrets.consumerBffUrl;
export const CONSUMER_FE_URL = secrets.consumerFeUrl;
export const BRN_RCD_PROJECT = true;
export const AIRSHIP_WEB_API_KEY = secrets.airshipWebApiKey;
export const AIRSHIP_ENV_KEY = secrets.airshipEnvKey;
export const INTERCOM_APP_ID = secrets.intercomAppId;
export const RAILS_URL = railsUrl;
export const DEPLOY_TYPE = deployType;
export const RAVEN_URL = 'https://710cd7e09a4c4a459babc784a2458196@sentry.io/305357';
export const MORTGAGE_SENTRY_URL = 'https://b229e65e13154d3fbab45c41e3d31e8d@sentry.io/2527980';
export const REDIRECT_URLS_REGEX = secrets.redirectURLsRegex;
